const Screen = {
    deltaBreakpoint: 0.02,
    breakpoints: {
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
        xxl: 1400,
    },
    mediaBreakpointDown(size) {
        return window.matchMedia(`(max-width: ${size - this.deltaBreakpoint}px)`).matches
    },
    mediaBreakpointUp(size) {
        return window.matchMedia(`(min-width: ${size}px)`).matches
    },
    mediaBreakpointHeightUp(size) {
        return window.matchMedia(`(min-height: ${size}px)`).matches
    },
}

export default Screen
